export const FilterSetAction = {
  NEW: "new",
  UPDATE: "update",
  DELETE: "delete",
};
